/* eslint-disable no-unused-vars */
import { Container, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles/";
import React from "react";
import globalColors from "../../../../../../_metronic/_assets/sass/custom/globalColors.scss";
import { AppAPIService } from "../../../../../services/AppAPIService";
import store from "../../../../../store/store";

import { getLabelAndColorFromStatusHelper } from "../../../../admin/pages/Lawsuit/helpers/getLabelAndColorFromStatusHelper";


import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../../partials/datatable/styles";

import {
  Table,
  TableBody,
  TableHead,
  TableRow
} from "@material-ui/core";

import { LabelWithBackLine } from "../../../../../components/LabelWithBackLine";
import { useMediaQuery } from "@mui/material";

export const UserDocumentHistoryTable = (props) => {
  const useStyles = makeStyles(() => {
    return {
      root: {
        maxHeight: "fit-content",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        minHeight: "75vh",
        borderRadius: "4px",
        boxShadow: `0 2px 4px rgba(0, 0, 0, 0.1)`,
      },
      paper: {
        width: "100%",
        flex: "1",
      },
      table: {
        minWidth: 400,
        overflowX: "scroll",
        background: `${globalColors.backgroundColor8}40`,
      },
      tableWrapper: {
        overflow: "hidden !important",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        height: "100%",
        overflowX: "auto",
        borderRadius: "4px",
        boxShadow: props.removeShadow
          ? "none"
          : "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
        border: "none",
      },
      tableContainer: {
        padding: "0 16px 0px 16px",
        marginTop: "5px",
      },
      search: {
        padding: 16,
      },
      input: {
        border: ".5px solid #707070",
        paddingRight: "10px",
        borderRadius: "4px",
        height: "48px",
        marginRight: "10px",
      },
      rows: {
        padding: "0 !important",
        margin: "0 !important",
      },
      addBtn: {
        padding: "16px 0",
        marginLeft: "16px",
      },
    };
  });
  const classes = useStyles();

  let api = AppAPIService.getInstance();
  const { auth } = store.getState();
  const srollableTable = useMediaQuery('(max-width: 768px)');

  const tableHeaders = ["Documento", "Data da Realição", "Status"];

  return (
    <>
      <div
        style={{
          minHeight: "35vh",
          maxHeight: "fit-content",
          borderRadius: "4px",
          boxShadow: "0px 1px 1px 1px rgba(0,0,0,0.2)",
          display: "flex",
          padding: "20px 20px 20px 20px",
        }}
        className={`${classes.root}`}
        maxWidth="xxl"
      >
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            style={{
              width: "100%",
            }}
          >
            <LabelWithBackLine>Histórico de documentos</LabelWithBackLine>
            <Container
              maxWidth="xl"
              style={{
                padding: 0,
                display: "flex",
                flexDirection: "column",
                marginTop: "20px",
              }}
            >
              <Container
                maxWidth="xl"
                style={{
                  boxShadow: "none",
                  border: "1px solid #e0e0e0",
                  borderRadius: "5px",
                  padding: 0,
                  textAlign: "left",
                  maxWidth: srollableTable ? 'calc(100vw - 70px)' : '100%',
                  overflowX: srollableTable ? "scroll" : "hidden",
                }}
              >
                <Table
                  className="table"
                  style={{
                    marginTop: "0px",
                    marginBottom: "0px",
                    padding: "0px",
                    borderCollapse: "collapse",
                    borderSpacing: "0px",
                    width: "100%",
                  }}
                >
                  <TableHead
                    style={{
                      backgroundColor: globalColors.secondaryColor3,
                    }}
                  >
                    <TableRow
                      style={{
                        textAlign: "left",
                        backgroundColor: globalColors.secondaryColor3,
                      }}
                    >
                      {tableHeaders.map((header, index) => (
                        <StyledTableCell
                          key={index}
                          style={{
                            textAlign: ["Status", "Data da Realição"].includes(
                              header
                            )
                              ? "center"
                              : "left",
                            backgroundColor: globalColors.secondaryColor3,
                            border: "none",
                          }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody
                    style={{
                      textAlign: "left",
                    }}
                  >
                    {props.historyData?.map((item) => (
                      <StyledTableRow
                        key={item.id}
                        style={{
                          backgroundColor:
                            item.id % 2 === 0
                              ? "#fffff"
                              : "rgba(225, 222, 219, 0.25)",
                        }}
                      >
                        <StyledTableCell
                          style={{
                            padding: "4px 10px",
                            textAlign: "left",
                          }}
                        >
                          {item.name}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{
                            padding: "4px 10px",
                            textAlign: "center",
                          }}
                        >
                          {item.completionDate &&
                            `${new Date(item.completionDate).toLocaleDateString(
                              "pt-BR"
                            )} às 
                            ${new Date(
                              item.completionDate
                            ).toLocaleTimeString()}`}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{
                            padding: "4px 10px",
                            textAlign: "center",
                            width: "100px",
                          }}
                        >
                          <Typography
                            style={{
                              backgroundColor: getLabelAndColorFromStatusHelper(
                                item.status
                              ).color,
                              display: "inline-block",
                              padding: "4px 6px",
                              margin: "0 4px",
                              borderRadius: "4px",
                              fontWeight: "500",
                              color: getLabelAndColorFromStatusHelper(
                                item.status
                              ).textColor,
                            }}
                          >
                            {
                              getLabelAndColorFromStatusHelper(item.status)
                                .label
                            }
                          </Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </Container>
            </Container>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
